import DOMPurify from "dompurify";

if (window.trustedTypes && window.trustedTypes.createPolicy) {
  // Feature testing
  window.trustedTypes.createPolicy("default", {
    createHTML: (string: any) =>
      DOMPurify.sanitize(string, {
        RETURN_TRUSTED_TYPE: true,
      }) as unknown as string,
    createScriptURL: (string: any) => string, // warning: this is unsafe!
    createScript: (string: any) => string, // warning: this is unsafe!
  });
}
import("./bootstrap");
